import axios from 'axios';
import Qs from 'qs';
import get from 'lodash/get';
import has from 'lodash/has';

import { redirectToLogin } from '../browserHistory';

/**
 * Adds the necessary authorization headers to the request.
 *
 * @param {AxiosConfig} config - the axios configuration to intercept
 * @returns {AxiosConfig}
 */
const addAuthHeadersInterceptor = (config) => {
  const csrftoken = get(
    document.getElementsByName('csrfmiddlewaretoken'),
    '0.value',
    '',
  );
  if (csrftoken) {
    config.headers['X-CSRFToken'] = csrftoken;
    if (has(config, 'data')) config.data['csrfmiddlewaretoken'] = csrftoken;
  }
  const apiToken = get(document.getElementById('api_token'), 'value', '');
  if (apiToken) config.headers['Authorization'] = `Token ${apiToken}`;
  return config;
};

/**
 * Appends a trailing slash to the endpoint, if it doesn't already have one.
 *
 * @param {AxiosConfig} config - the axios configuration to intercept
 * @returns {AxiosConfig}
 */
export const appendTrailingSlashInterceptor = (config) => {
  if (!config.url.endsWith('/')) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`${config.url} should have a trailing "/"`);
    }
    config.url = config.url + '/';
  }
  return config;
};

const createAxiosInstance = (baseURL, addTrailingSlash = true) => {
  const sensusApi = axios.create({
    baseURL: baseURL,
    paramsSerializer: Qs.stringify.bind(Qs),
  });

  sensusApi.interceptors.request.use(addAuthHeadersInterceptor);
  if (addTrailingSlash) {
    sensusApi.interceptors.request.use(appendTrailingSlashInterceptor);
  }

  sensusApi.interceptors.response.use(
    (res) => res,
    (e) => {
      if (e.response && e.response.status === 401) {
        redirectToLogin();
        if (typeof localStorage === 'object') {
          localStorage.removeItem('emotive_client_portal_hide_header');
        }
      }
      // eslint-disable-next-line no-undef
      return Promise.reject(e);
    },
  );

  return sensusApi;
};

export const api = createAxiosInstance('/api', false);
export const brandAPI = createAxiosInstance('/api/brand');
export const onBoardingApi = createAxiosInstance('/onboarding');
export const discountCodeApi = createAxiosInstance('/api/discount_codes');
